import React, {useState, useEffect} from 'react'
import datas from '../../datas/Datas'
// import JobCard from '../../components/Cards/JobCard'
import {TRAINING_API_END_POINT as api, END_POINT} from "../../../utils/constant"
import { useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import icon1 from "../../assets/jobIcons/icon1.svg"
import {formatDateTime, formatSalary} from "../../../components/DateTimeConverter/DateTimeConverter"
import FormationCard from '../../components/Cards/FormationCard'
import ImageWithFallback from '../../components/ImageWithFallback';
import EnrollmentModal from '../../../components/Modal/EnrollmentModal';
import CongratsModal from '../../../components/Modal/CongratsModal';


import { useSelector } from 'react-redux';
import { FaChalkboardTeacher, FaHourglassHalf, FaMoneyBillWave, FaCalendarAlt, FaRegCalendarCheck, FaChalkboard } from 'react-icons/fa';
import FAQSection from '../Home/partials/FAQSection';


const FormationDetail = () => {
  const { pathname } = useLocation();
  const { id } = useParams(); // Récupérer l'id de la formation
  const [formation, setFormation] = useState(null);
  const [similarTraining, setSimilarTraining] = useState(null)
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false)
  const {user} = useSelector(store=>store.user)
  const [showConfetti, setshowConfetti] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchFormationDetails();
  }, [pathname]);

  const fetchFormationDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${api}/findWithSimilar/${id}`);
      setFormation(response.data?.training);
      setSimilarTraining(response.data?.similar_trainings) // Si l'API retourne des formations similaires
      console.log("formation: ",response.data)
      // setJobs(response.data.similarJobs); 
      setLoading(false);
    } catch (err) {
      setError("Une erreur est survenue lors de la récupération des détails.");
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    showConfetti(true)
    alert("Votre inscription a bien été envoyée avec succès !");
    setTimeout(() => {
      showConfetti(false)
    }, 2000);
  };

  if (loading) return <div>Chargement...</div>;
  if (error) return <div>{error}</div>;

  const icons = {
    "Type de cours": <FaChalkboardTeacher className="text-2xl text-primary" />,
    "Durée": <FaHourglassHalf className="text-2xl text-primary" />,
    "Tarif": <FaMoneyBillWave className="text-2xl text-primary" />,
    "Date de début": <FaCalendarAlt className="text-2xl text-primary" />,
    "Date de fin": <FaRegCalendarCheck className="text-2xl text-primary" />,
  };

  return (
    <>
      <div
        className="mb-6 rounded-lg h-56 mx-10 xl:mx-20 mt-10 bg-gray-800"
        style={{
          backgroundImage: `url(${END_POINT+"/storage"+formation?.image || "placeholder.jpg"})`,
          objectFit: "cover",
          backgroundSize: "100%",
        }}
      >
        {/* {END_POINT+"/storage"+formation?.training?.image} */}
        <div className="absolute mb-6 mt-[120px] ml-10 xl:ml-20 bg-gray-50 border-2 rounded-md flex justify-center items-center w-28 h-20 shadow overflow-hidden">
        <ImageWithFallback src={END_POINT+"/storage"+formation?.user?.organisation_profile?.logo} className=" object-cover" defaultType="logo"/>
        </div>
        
      </div>

      <div className="w-full px-20 xl:px-40 space-y-4 text-start mb-6">
        <h4 className="text-4xl font-bold">{formation?.title || "Titre de la Formation"}</h4>
        <p className="text-xl text-gray-600">{formation?.user?.nom || "Nom du formateur"}</p>
        <div className="flex items-center gap-4">
          <span>{formation?.location || "Lieu non spécifié"}</span>
          <div className="px-4 py-2 bg-green-100 text-green-800 rounded-full">
            {formation?.type || "Type non spécifié"}
          </div>
        </div>
      </div>

      <div className="p-responsive flex justify-between   gap-10 mb-10">
      <div className="w-full lg:w-2/3 text-justify space-y-6">
      <div>
        <h4 className="text-xl font-bold mb-2">A propos du centre</h4>
        <p>{formation?.user?.description || "Aucune description disponible."}</p>
      </div>
      <div>
        <h4 className="text-xl font-bold mb-2">Prérequis</h4>
        <p>{formation?.required_profile || "Aucun."}</p>
      </div>
      <div>
        <h4 className="text-xl font-bold mb-2">Objectifs de la formation</h4>
        <p>{formation?.objective || "Objectifs non spécifiés."}</p>
      </div>
      <div>
        <h4 className="text-xl font-bold mb-2">Programme</h4>
        <p>{formation?.description || "Programme non disponible."}</p>
      </div>
    </div>

        <div className="w-1/3 h-[520px] bg-white border-2 border-gray-300 rounded-2xl sticky top-20">
          <h5 className="text-xl font-semibold py-4 text-start px-6">Information générale</h5>


          {[
        { label: "Type de cours", value: formation?.type },
        { label: "Durée", value: formation?.duration },
        // { label: "Droit", value: formatSalary(formation?.fees) },
        { label: "Tarif", value: formatSalary(formation?.fees) },
        { label: "Date de début", value: formatDateTime(formation?.training_start_at) },
        { label: "Date de fin", value: formatDateTime(formation?.training_end_at) },
      ].map(({ label, value }) => (
        <div key={label} className="border-b flex gap-4 items-center py-4 mx-6">
        {icons[label] || <FaChalkboard className="text-3xl text-primary" />}
        <div className="flex justify-between flex-col text-start">
          <div className='text-sm text-primary-text'>{label}</div>
          <div className='font-semibold'>{value || "Non spécifié"}</div>
        </div>
      </div>  
      ))}

          <div className="w-full px-4">
            <button onClick={()=>setShowModal(true)} className="w-full rounded-md py-4 bg-primary-black text-white font-medium">
              S'inscrire Maintenant
            </button>
          </div>
        </div>
      </div>

      <div className="w-full py-20 px-20 lg:px-40 bg-primary-beige">
        <div className="flex justify-between items-center mb-10">
          <h4 className="text-4xl font-bold">Formation similaires</h4>
          <button className="flex items-center gap-2 px-4 py-2 border-2 border-primary-black font-bold text-primary-black">
            Voir tout
          </button>
        </div>
        <div className="grid grid-cols-1 gap-6">
          {similarTraining?.map((item) => (
            <FormationCard key={item.id} item={item} />
          ))}
        </div>
      </div>
      <FAQSection/>

      <EnrollmentModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmitSuccess={handleSuccess}
        user={user}
        training={formation}
        setshowConfetti={()=>setshowConfetti(false)}
      />
    

    </>
  );
};

export default FormationDetail;
